module.exports = __webpack_public_path__ + "img/cake-14.923ba681.svg";